'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.reduce = reduce;
exports.getSelectedLog = getSelectedLog;
exports.getSelectedSnapshotItemIndex = getSelectedSnapshotItemIndex;
exports.getSelectedSnapshotItem = getSelectedSnapshotItem;

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = exports.initialState = {
  logs: [],
  selectedLog: null,
  selectedSnapshotItems: {}
};


function getDefaultSnapshotItemIndex(snapshot) {
  if (snapshot.length !== 0) {
    var defaultSnapshotItem = snapshot[0];
    if (defaultSnapshotItem.type === 'All') {
      var index = getDefaultSnapshotItemIndex(defaultSnapshotItem.snapshots[0]);
      return index ? [0, 0].concat(_toConsumableArray(index)) : null;
    }
    return [0];
  }
  return null;
}

function reduce(state, commit) {
  switch (commit.type) {
    case 'AddLog':
      {
        var _selectedLog = typeof state.selectedLog !== 'number' ? state.logs.length : state.selectedLog;
        var _logs = [].concat(_toConsumableArray(state.logs), [{
          action: commit.action,
          serialized: false,
          snapshot: commit.snapshot
        }]);
        return _extends({}, state, {
          logs: _logs,
          selectedLog: _selectedLog,
          selectedSnapshotItems: state.selectedSnapshotItems[_selectedLog] ? state.selectedSnapshotItems : _extends({}, state.selectedSnapshotItems, _defineProperty({}, _selectedLog, getDefaultSnapshotItemIndex(_logs[_selectedLog].snapshot)))
        });
      }
    case 'Clear':
      return initialState;
    case 'SelectLog':
      return commit.logIndex === state.selectedLog ? state : _extends({}, state, {
        selectedLog: commit.logIndex,
        selectedSnapshotItems: state.selectedSnapshotItems[commit.logIndex] ? state.selectedSnapshotItems : _extends({}, state.selectedSnapshotItems, _defineProperty({}, commit.logIndex, getDefaultSnapshotItemIndex(state.logs[commit.logIndex].snapshot)))
      });
    case 'SelectSnapshotItem':
      return typeof state.selectedLog !== 'number' ? state : _extends({}, state, {
        selectedSnapshotItems: _extends({}, state.selectedSnapshotItems, _defineProperty({}, state.selectedLog, commit.snapshotItemIndex))
      });
    case 'ShowSerializedSnapshot':
      return _extends({}, state, {
        logs: state.logs.map(function (log, index) {
          return index === state.selectedLog ? _extends({}, log, { serialized: true }) : log;
        })
      });
    default:
      return state;
  }
}

function getSelectedLog(state) {
  return typeof state.selectedLog === 'number' ? state.logs[state.selectedLog] : null;
}

function getSelectedSnapshotItemIndex(state) {
  return typeof state.selectedLog === 'number' ? state.selectedSnapshotItems[state.selectedLog] : null;
}

function extractSnapshotItem(snapshot, index) {
  if (index.length === 0) {
    return null;
  }

  var _index = _toArray(index),
      firstIndex = _index[0],
      secondIndex = _index[1],
      otherIndexes = _index.slice(2);

  var item = snapshot[firstIndex];
  if (item) {
    if (item.type === 'All' && typeof secondIndex === 'number') {
      return extractSnapshotItem(item.snapshots[secondIndex], otherIndexes);
    }
    return item;
  }
  return null;
}

function getSelectedSnapshotItem(state) {
  var selectedLog = getSelectedLog(state);
  var selectedSnapshotItemIndex = getSelectedSnapshotItemIndex(state);
  return selectedLog && selectedSnapshotItemIndex && extractSnapshotItem(selectedLog.snapshot, selectedSnapshotItemIndex);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/devtools/dist/main/model.js
 ** module id = 86
 ** module chunks = 0
 **/